import { useEffect, useState } from "react";
import Table from "../../extras/Table";
import { useDispatch, useSelector } from "react-redux";
import {
  acceptWithDraw,
  getExpertWithDraw,
  rejectedWithDraw,
} from "../../../redux/slice/withDrawSlice";
import { toast } from "react-toastify";
import Button from "../../extras/Button";
import Pagination from "../../extras/Pagination";
import { AcceptWarning, permissionError, warning } from "../../../util/Alert";
import moment from "moment";
import { IconCircleDashedCheck, IconCircleDashedX, IconEye } from "@tabler/icons-react";

import { Box, Modal } from "@mui/material";
import LazyImage from "../../extras/ImageFallback";

const PendingRequest = ({ status, startDate, endDate }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const { setting } = useSelector((state) => state.setting);
  const hasPermission = useSelector((state) => state.auth.admin.flag);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modal, setModal] = useState(false);
  const [reason, setReason] = useState("");
  const [data, setData] = useState("");
  const [rejectedId, setRejectedId] = useState("");
  const [paymentDetailsModal, setPaymentDetailsModal] = useState(false);
  const { expertWithDraw, total } = useSelector((state) => state.withDraw);
  useEffect(() => {
    const payload = {
      start: page,
      limit: rowsPerPage,
      status: status,
      startDate: startDate === "ALL" ? "All" : startDate,
      endDate: endDate === "ALL" ? "All" : endDate,
    };
    dispatch(getExpertWithDraw(payload));
  }, [startDate, endDate]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };
  const handleOpenImgae = (image) => {
    window.open(image, "_blank");
  };
  const handleAccept = async (id) => {
    try {
      const data = await AcceptWarning("Accept");
      const yes = data?.isConfirmed;
      console.log("yes", yes);
      if (!hasPermission) return permissionError();

      if (yes) {
        dispatch(acceptWithDraw(id)).then((res) => {
          console.log("ressssssss", res);
          if (res?.payload?.status) {
            toast.success(res?.payload?.message);
            const payload = {
              start: page,
              limit: rowsPerPage,
              status: status,
              startDate: startDate === "ALL" ? "All" : startDate,
              endDate: endDate === "ALL" ? "All" : endDate,
            };
            dispatch(getExpertWithDraw(payload));
          } else {
            toast.error(res?.payload?.message);
          }
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!hasPermission) return permissionError();

    const payload = {
      id: rejectedId,
      reason: reason,
    };
    dispatch(rejectedWithDraw(payload)).then((res) => {
      console.log("resssssss", res);
      if (res?.payload?.status) {
        toast.success(res?.payload?.message);
        const payload = {
          start: page,
          limit: rowsPerPage,
          status: status,
          startDate: startDate === "ALL" ? "All" : startDate,
          endDate: endDate === "ALL" ? "All" : endDate,
        };
        dispatch(getExpertWithDraw(payload));
        setModal(false);
        setReason("");
      } else {
        toast.error(res?.payload?.message);
      }
    });
  };
  const pendingTable = [
    {
      Header: "SR NO",
      Cell: ({ index }) => (
        <span>{page * rowsPerPage + parseInt(index) + 1}</span>
      ),
    },
    {
      Header: "Expert Image",
      Cell: ({ row }) => (
        <div className="userProfile d-flex justify-content-center align-items-center">
          <LazyImage
            src={row?.expert?.image}
            alt="expert"
            // className="cursor-pointer"
            style={{ height: "50px", width: "50px", overflow: "hidden" }}
            // onClick={(e) => {
            //   handleOpenImgae(row?.expert?.image);
            // }}
          />
        </div>
      ),
    },
    {
      Header: "Expert Name",
      Cell: ({ row }) => (
        <>

          {row?.expert?.fname + " " + row?.expert?.lname
            ? row?.expert?.fname + " " + row?.expert?.lname
            : "-"}

        </>
      ),
    },
    {
      Header: `Amount (${setting?.currencySymbol || "$"})`,
      Cell: ({ row }) => (
        <>
          {row?.amount ? row?.amount : "-"}
        </>
      ),
    },
    {
      Header: "Date",
      Cell: ({ row }) => (
        <>
          <div>
            {moment(row?.createdAt).format("DD-MM-YYYY")
              ? moment(row?.createdAt).format("DD-MM-YYYY")
              : "-"}
          </div>
        </>
      ),
    },
    {
      Header: "Action",
      Cell: ({ row }) => (
        <div className="action-button">
          <button
            className="btn btn-sm"
            onClick={() => {
              
              setPaymentDetailsModal(true);
              setData(row);
            }}
          >
            <IconEye className="text-secondary" />
          </button>
          <button
            className="btn btn-sm"
            onClick={() => {
              handleAccept(row?._id);
            }}
          >
            <IconCircleDashedCheck className="text-secondary" />
          </button>
          <button
            className="btn btn-sm"
            onClick={() => {
              setModal(true);
              setRejectedId(row?._id);
            }}
          >
            <IconCircleDashedX className="text-secondary" />
          </button>
        </div>
      ),
      width: "50px",
    },
    // {
    //   Header: "Accept",
    //   body: "",
    //   Cell: ({ row }) => (
    //     <>
    //       <i
    //         className="fa-solid fa-check"
    //         style={{ color: "green", fontSize: "18px" }}

    //       ></i>
    //     </>
    //   ),
    // },
    // {
    //   Header: "Reject",
    //   body: "",
    //   Cell: ({ row }) => (
    //     <>
    //       <i
    //         className="fa-sharp fa-solid fa-xmark"
    //         style={{ color: "red", fontSize: "18px" }}
    //         onClick={() => {
    //           setModal(true);
    //           setRejectedId(row?._id);
    //         }}
    //       ></i>
    //     </>
    //   ),
    // },
  ];
  return (
    <>
      <Table
        data={expertWithDraw}
        mapData={pendingTable}
        PerPage={rowsPerPage}
        Page={page}
        type={"client"}
      />
      <Pagination
        type={"server"}
        serverPage={page}
        setServerPage={setPage}
        serverPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        totalData={total}
      />
      
        <>
          <Modal
            open={paymentDetailsModal}
          onClose={()=>{setPaymentDetailsModal(false)}}
          >
            <Box className="model-style">
              <div className="model-header">
                <p className="m-0">Payment Details</p>
              </div>
              <div className="model-body">
               
                
                    <div className="col-12 mb-3">
                      <label className="fs-15">Payment GateWay</label>
                      <input
                        type="text"
                        className="form-control"
                        value={data?.paymentGateway}
                        name="paymentGateway"
                        disabled
                      />
                    </div>
                    <div className="col-12 mb-3">
                      <label className="fs-15">Payment Details</label>

                      {data?.paymentDetails?.map((item, index) => {
                        const [label, value] = item.split(":");

                        return (
                          <div className="inputData mt-2" key={index}>
                            <label>{label}</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder={`Enter your ${label.toLowerCase()}`}
                              value={value?.trim()}
                              disabled
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                
            
                 <div className="model-footer">
                    <div className="m-3 d-flex justify-content-end gap-2">
                      <Button
                        type={`cancel`}
                         className={`close-model-btn`}
                        text={`Cancel`}
                        onClick={() => {
                          setPaymentDetailsModal(false);
                        }}
                      />
                    </div>
                  </div>
            </Box>
          </Modal>

        </>
     

      
        <>
              <Modal
                open={modal}
                onClose={()=> setModal(false)}
              >
               <Box className="model-style">
               <div className="model-header">
          <p className="m-0">Reason</p>
        </div>
                  <div className="model-body">
                      <div className="row align-items-start formBody">
                        <div className="col-12 mb-3">
                          <label>Reason</label>
                          <input
                            type="text"
                            placeholder="Enter reason"
                            className="form-control"
                            value={reason}
                            onChange={(e) => {
                              setReason(e.target.value);
                            }}
                            name="reason"
                          />
                        </div>
                      </div>
                    
                  </div>
                     <div className="model-footer">
                        <div className="m-3 d-flex justify-content-end gap-2">
                          <Button
                             className={`close-model-btn`}
                            text={`Cancel`}
                            type={`button`}
                            onClick={() => {
                              setModal(false);
                              setReason("");
                            }}
                          />
                          <Button
                            type={`submit`}
                            text={`Submit`}
                            onClick={(e) => handleSubmit(e)}
                          />
                        </div>
                      </div>

               </Box>
              </Modal>

        </>
     
    </>
  );
};
export default PendingRequest;
